import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonComponentsModule } from '../../../../../../../../SUVO-CORE-CLIENT-LIB/projects/suvo-core-client-lib/src/lib/features/common-components/common-components.module';
import { AngularMaterialModule } from '../angular-material/angular-material-module';

const imports = [
  AngularMaterialModule,
  ReactiveFormsModule,
  FlexLayoutModule,
  FormsModule,
  RouterModule,
  CommonComponentsModule,
];

@NgModule({
  imports,
  exports: imports,
})
export class SharedModule {}
